import { logger } from 'common/services/logger';
import { assert, generateDynamicPath } from 'common/utils';
import { natalieEventApi } from 'natalie/api/natalieEventApi';
import { isTestLinkSearch } from 'pages/Natalie/NatalieForParticipant/RoomLiveKit/hooks/useTestInviteCode';
import { buildPostRegistrationPath } from 'pages/Natalie/navigation';
import { NatalieRoutes } from 'pages/Natalie/routes';
import { push } from 'redux-first-history';

import type { natalieActions } from './natalie.actions';
import type { Effect } from 'store';

export const startChattingButtonClickedEffect: Effect<
  ReturnType<typeof natalieActions.detailsPage.startChattingButton.clicked>
> = ({ payload: { id } }, { dispatch, getState }) => {
  const searchParams = window.location.search;
  const natalieEvent = natalieEventApi.endpoints.getNatalieEvent.select({
    id,
    isTestLink: isTestLinkSearch(searchParams),
  })(getState()).data;

  dispatch(push(buildPostRegistrationPath(id, natalieEvent?.communityId, searchParams), { allow: true }));
};

export const joinButtonClickedEffect: Effect = ({ payload: { id } }, { dispatch, getState }) => {
  try {
    const state = getState();
    // Resolved from the click's own event id rather than the current pathname.
    const natalieEvent = natalieEventApi.endpoints.getNatalieEvent.select({
      id,
      isTestLink: isTestLinkSearch(window.location.search),
    })(state).data;

    assert(!!natalieEvent, 'Natalie event is not present');

    const hasVideo = !!natalieEvent.videoUrl;
    const searchParams = window.location.search;

    const route = hasVideo ? NatalieRoutes.WaitingRoom : NatalieRoutes.RoomLiveKit;

    // Preserve query params for the navigation
    const path = generateDynamicPath(route, { id }) + searchParams;
    dispatch(push(path, { allow: true }));
  } catch (error) {
    logger.error(error);
  }
};

export const beforeJoinContinueButtonClickedEffect: Effect<
  ReturnType<typeof natalieActions.beforeJoinPage.continueButton.clicked>
> = ({ payload: { id } }, { dispatch }) => {
  const searchParams = window.location.search;
  dispatch(push(generateDynamicPath(NatalieRoutes.Join, { id }) + searchParams, { allow: true }));
};
